import { AppRoute, NavigationLinkBase } from '@ebeihilfe/core';
import { Injectable } from '@angular/core';

@Injectable()
export class StartseiteNavLink extends NavigationLinkBase {
  public mdIcon = 'home';
  public itemType = 'icon';

  constructor() {
    super('STARTSEITE', 'menu.label.dashboard', `/${AppRoute.DashboardPage}`, 'a11y.link.dashboard');
  }
}
